// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Import server Config
import apiLink from '@configs/serverConfig'

// ** Axios Imports
import axios from 'axios'

// ** Suppliers
export const getSuppliersList = createAsyncThunk('appSuppliers/getSuppliersList', async params => {
    params.page = params.page === 0 ? 0 : params.page - 1
    
    const response = await axios.post(`https://api.mfauto.com.ua/suppliers/list?env=${process.env.REACT_APP_NODE_ENV}`, {
        ...params,
        token: localStorage.getItem('token')
    })

    return {
        params,
        data: response.data.suppliers,
        totalPages: response.data.total_elements
    }
    /*
    const response = await axios.get(apiLink('getSuppliers', params))    

    // ** eof issue
    return {
        params,
        data: response.data.content,
        totalPages: response.data.totalElements
    }*/
})
export const addSupplier = createAsyncThunk('appSuppliers/addSupplier', async (data) => {
    const response = await axios.post(apiLink('addSupplier'), data)
    return response.data
})
export const updateSupplier = createAsyncThunk('appSuppliers/updateSupplier', async (data) => {
    const response = await axios.put(apiLink({name: 'updateSupplier', value: data.id}), data)
    return response.data
})
export const getSupplier = createAsyncThunk('appSuppliers/getSupplier', async (id) => {
    const response = await axios.get(apiLink({name: 'getSupplier', value: id}))
    return response.data
})
export const removeSupplier = createAsyncThunk('appSuppliers/removeSupplier', async (id) => {
    const response = await axios.delete(apiLink({name: 'removeSupplier', value: id}))
    return response.data
})
export const getSupplierMutualSettlements = createAsyncThunk('appSuppliers/getSupplierMutualSettlements', async id => {
   const response = await axios.post(`https://api.mfauto.com.ua/suppliers/get-mutual-settlement?env=${process.env.REACT_APP_NODE_ENV}`, {
      supplier_id: id,
      token: localStorage.getItem('token')
   })
   return response.data
})

// ** Supplies
export const getSuppliesList = createAsyncThunk('appSuppliers/getSuppliesList', async data => {
    data.page = data.page === 0 ? 0 : data.page - 1
    
    const response = await axios.post(`https://api.mfauto.com.ua/supplies/get?env=${process.env.REACT_APP_NODE_ENV}`, {
        ...data,
        token: localStorage.getItem('token')
    })

    return {
        params: data,
        data: response.data.supplies,
        totalPages: response.data.total_elements
    }

    //const response = await axios.post(apiLink('getSuppliesList'), data)    
    /*
    return {
        params: data,
        data: response.data.content,
        totalPages: response.data.totalElements
    }*/
})
export const addSupply = createAsyncThunk('appSuppliers/addSupply', async (data) => {
    const response = await axios.post(apiLink('addSupply'), data)
    return response.data
})
export const getSupply = createAsyncThunk('appSuppliers/getSupply', async (id) => {
    const response = await axios.get(apiLink({name: 'getSupply', value: id}))
    return response.data
})

// ** Payments
export const addSupplyPayment = createAsyncThunk('appSuppliers/addPayment', async (data) => {
    return await axios.post(apiLink('addPayment'), data)
})
export const removeSupplyPayment = createAsyncThunk('appSuppliers/removeRentPayment', async (id) => {
    const response = await axios.delete(apiLink({name: 'removePayment', value: id}, {type: 'SERVICE_STATION_SUPPLY'}))
    return response.data
})

export const appSuppliersSlice = createSlice({
    name: 'appSuppliers',
    initialState: {
        suppliers: [],
        supplies: [],
        total: 1,
        params: {},
        settings: [],
        selectedSupplier: null,
        selectedSupply: null
    },
    reducers: {},
    extraReducers: builder => {
        builder
        .addCase(getSuppliersList.fulfilled, (state, action) => {
            state.suppliers = action.payload.data
            state.params = action.payload.params
            state.total = action.payload.totalPages
        })
        .addCase(getSuppliesList.fulfilled, (state, action) => {
            state.supplies = action.payload.data
            state.params = action.payload.params
            state.total = action.payload.totalPages
        })   
        .addCase(getSupply.fulfilled, (state, action) => {
            state.selectedSupply = action.payload
        })    
    }
})

export default appSuppliersSlice.reducer
